module.exports = __webpack_public_path__ + "img/24.33f25649.png";